import { AUTHENTICATION } from "./authenticationConstants.js";
import { decodeTokenPayload } from "./authenticationUtils.js";
import { API_ERROR, API_ERROR_RESET } from "../../actions/actionConstants.js";

export const INITIAL = {
  isReady: false, // set once we've checked to see if there is a currently valid refresh token on startup
  isFetching: false,
  isInactivityWarning: false,
  authenticationError: null,
  isAuthenticated: false,
  lastActivity: 0,
  iat: 0,
  exp: 0,
  sub: null,
  tokens: {
    token: null,
    refresh: null
  }
};

export const authenticationReducer = (state = INITIAL, action = {}) => {
  switch (action.type) {
    // -- LOGIN -- //

    case AUTHENTICATION.LOGIN.DO:
      // console.log("AUTHENTICATION.LOGIN.DO");
      return {
        ...state,
        isFetching: true
      };

    case AUTHENTICATION.LOGIN_FEDERATED_LINK.DO:
      // console.log("AUTHENTICATION.LOGIN_FEDERATED_LINK.DO");
      return {
        ...state,
        isFetching: true,
        federatedError: null
      };

    case AUTHENTICATION.LOGIN_FEDERATED_LINK.FAILURE:
      // console.log("AUTHENTICATION.LOGIN_FEDERATED_LINK.FAILURE");
      return {
        ...state,
        isFetching: false,
        federatedError:
          action.payload?.message || "No federated login provider found."
      };

    case AUTHENTICATION.LOGIN_FEDERATED_LINK.CLEAR_ERROR:
      return {
        ...state,
        federatedError: null
      };

    case AUTHENTICATION.LOGOUT.DO:
      // console.log("AUTHENTICATION.LOGOUT.DO");
      return {
        ...state,
        isAuthenticated: false, // premptively setting this as otherwise we have all kinds of unexpected render issues - especially with Dashboard
        isFetching: true
      };

    case AUTHENTICATION.LOGOUT.RECEIVE:
      // console.log("AUTHENTICATION.LOGOUT.RECEIVE");
      return {
        ...INITIAL,
        isReady: state.isReady
      };

    case AUTHENTICATION.LOGOUT.FAILURE:
      // console.log("AUTHENTICATION.LOGOUT.FAILURE:", action);
      return {
        ...INITIAL,
        isReady: state.isReady,
        isFetching: false
      };

    case AUTHENTICATION.LOGOUT.POST_COMPLETE:
      // console.log("AUTHENTICATION.LOGOUT.POST_COMPLETE:", action);
      return {
        ...state,
        isFetching: false
      };

    case AUTHENTICATION.LOGIN.RECEIVE:
      const stateFromTokens = decodeTokenPayload(action.payload);
      // console.log("TOKENS:", stateFromTokens);

      return {
        ...state,
        ...stateFromTokens,
        isFetching: false
      };

    case AUTHENTICATION.LOGIN.FAILURE:
      // console.log("AUTHENTICATION.LOGIN.FAILURE:", action);
      const authenticationError = action.payload.status;

      return {
        ...INITIAL,
        isReady: state.isReady,
        authenticationError,
        isFetching: false
      };

    // -- REFRESH -- //

    case AUTHENTICATION.REFRESH.DO:
      // console.log("AUTHENTICATION.REFRESH.DO");
      return {
        ...state,
        isFetching: true
      };

    // -- INACTIVITY -- //

    case AUTHENTICATION.LAST_ACTIVITY:
      // console.log("AUTHENTICATION.LAST_ACTIVITY");
      return {
        ...state,
        ...action.payload
      };

    case AUTHENTICATION.INACTIVITY_WARNING.DO:
      return {
        ...state,
        isInactivityWarning: true
      };

    case AUTHENTICATION.INACTIVITY_WARNING.RESET:
      return {
        ...state,
        isInactivityWarning: false
      };

    // -- STARTUP -- //

    // startup completed and a valid refresh token was found
    // set the isReady flag
    case AUTHENTICATION.STARTUP_SUCCESS:
      return {
        ...state,
        isReady: true
      };

    // startup completed but no valid refresh token was found
    // reset everything and set the isReady flag
    case AUTHENTICATION.STARTUP_FAILED:
      // console.log("reducer AUTHENTICATION.STARTUP_FAILED");
      return {
        ...INITIAL,
        isReady: true
      };

    // -- GENERAL RESET -- //

    // reset everything - will need to startup again
    case AUTHENTICATION.RESET:
      return INITIAL;

    // -- GENERAL ERRORS -- //

    case API_ERROR_RESET:
      return {
        ...state,
        authenticationError: null
      };

    case API_ERROR:
      return state;

    default:
      return state;
  }
};

export default {};
